import { useMemo } from "react";
import AdsBanner from "../Ads";
import useMediaQuery from "@/utils/useMediaQuery";
import { PHONE_TABLET_MEDIA_QUERY, TABLET_MEDIA_QUERY } from "../../constants/breakpoints";
import { CONFIG } from "@/config";

const AdsMobileBanner: React.FC = () => {
  const isPhoneTablet = useMediaQuery(PHONE_TABLET_MEDIA_QUERY);
  const isTablet = useMediaQuery(TABLET_MEDIA_QUERY);

  const height = useMemo(() => {
    const heightMap = {
      tablet: "114px",
      phoneTablet: "86px",
      default: "54px",
    };

    if (isTablet) return heightMap.tablet;
    if (isPhoneTablet) return heightMap.phoneTablet;

    return heightMap.default;
  }, [isPhoneTablet, isTablet]);

  return (
    <AdsBanner
      display="inline-block"
      dataAdSlot={CONFIG.MOBILE_ADS_SLOT}
      width={"100%"}
      height={height}
      isResponsive={false}
    />
  );
};

export default AdsMobileBanner;
